import { defaultLanguages } from "$lib/data/defaultLanguages";

export const getRequiredTranslations = (languageDocs, update = {}) => {
    const languages =
        { ...defaultLanguages, ...languageDocs };
    delete languages.index;

    const requiredTranslations = Object.keys(languages)
        .map(k => ({ code: languages[k]?.value?.code?.value, label: languages[k]?.value?.label?.value }))
        .filter((language) => language.code && !update?.translations?.[language.code])
        .reduce(
            (a, language) => ({
                ...a,
                [language.code]: ''
            }),
            {}
        );

    return requiredTranslations;
};
